import { H5 } from 'foundations-components/transitional/components/H5';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const buildSlideshowSteps = steps => steps.map(step => {
  if (step.illustration) {
    return {
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: step.title
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: step.description
        })]
      }),
      content: /*#__PURE__*/_jsx(Illustration, {
        height: 230,
        name: step.illustration
      }),
      alt: ''
    };
  } else {
    return {
      content: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: step.title
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: step.description
        })]
      }),
      alt: ''
    };
  }
});